var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { JP_PREFECTURES } from '../constants/roasterValues';
var postalCodeRegExp = /^[0-9a-zA-Z]+$/;
var phoneRegExp = /^\d+$/;
var emailRegExp = /^[^\s]+@[^\s]+$/;
var integerRegExp = /^\d+$/;
var integerOrBlankRegExp = /^(\d+)?$/;
export var decimalRegExp = /^\d+(\.\d+)?$/;
export var numberRegExp = /^-?\d+$/;
var japanRegExp = {
    prefecture: new RegExp("^(".concat(JP_PREFECTURES.join('|'), ")*$")),
    city: /^([\u3041-\u3096\u30A1-\u30FA々〇〻\u3400-\u9FFF\uF900-\uFAFF]|[\uD840-\uD87F][\uDC00-\uDFFF]){1,12}$/,
    postalCode: /^[0-9]{7}$/,
    address: /^[^ \u3000]+$/,
};
export var OrderFieldFormats = {
    postal_code: postalCodeRegExp,
    phone: phoneRegExp,
    email: emailRegExp,
};
export var AddressFormats = OrderFieldFormats;
export var JapanAddressFormats = __assign(__assign({}, AddressFormats), { prefecture: japanRegExp.prefecture, city: japanRegExp.city, postal_code: japanRegExp.postalCode, address: japanRegExp.address });
export var RoasterFieldFormats = [
    {
        field: 'postal_code',
        regexp: postalCodeRegExp,
        error: 'alphanumeric',
    },
    {
        field: 'phone',
        regexp: phoneRegExp,
        error: 'integer',
    },
    {
        field: 'email',
        regexp: emailRegExp,
        error: 'invalid',
    },
    {
        field: 'roaster_max_capacity',
        regexp: decimalRegExp,
        error: 'decimal',
    },
    {
        field: 'roasted_per_month',
        regexp: integerRegExp,
        error: 'integer',
    },
    {
        field: 'store_count',
        regexp: integerOrBlankRegExp,
        error: 'integer',
    },
];
export var JapanRoasterFieldFormats = RoasterFieldFormats.concat([
    {
        field: 'prefecture',
        regexp: japanRegExp.prefecture,
        error: 'isRequired',
    },
    {
        field: 'city',
        regexp: japanRegExp.city,
        error: 'invalidCity',
    },
    {
        field: 'postal_code',
        regexp: japanRegExp.postalCode,
        error: 'invalidPostalCode',
    },
    {
        field: 'address',
        regexp: japanRegExp.address,
        error: 'invalid',
    },
]);
var japanRoasterAddressLength = function (address) {
    return (Array.from(address.matchAll(/[\x20-\x7Eｧ-ﾝﾞﾟ]/g)).length +
        Array.from(address.matchAll(/[^(\x20-\x7Eｧ-ﾝﾞﾟ)]/g)).length * 2);
};
export var JapanRoasterAddressHalfWidthMaxLength = 32;
export var JapanRoasterBuildingHalfWidthMaxLength = 50;
export var japanRoasterAddressTest = function (address) {
    return japanRoasterAddressLength(address) <= JapanRoasterAddressHalfWidthMaxLength;
};
export var japanRoasterBuildingTest = function (building) {
    return japanRoasterAddressLength(building) <= JapanRoasterBuildingHalfWidthMaxLength;
};
export var TaiwanRoasterFieldFormats = RoasterFieldFormats.concat([
    {
        field: 'phone',
        regexp: /^0\d{8,9}$/,
        error: 'invalid',
    },
    {
        field: 'business_number_tw',
        regexp: /^\d{8}$/,
        error: 'invalid',
    },
]);
export var DeliveryRequestFieldFormats = {
    postal_code: postalCodeRegExp,
    phone: phoneRegExp,
};
export var ProducerFieldFormats = [
    {
        field: 'phone',
        regexp: phoneRegExp,
        error: 'integer',
    },
];
